import React from 'react'
import './Program.css'
import right from '../../assets/rightArrow.png'
import {programsData} from '../../data/programsData';

export const Program = () => {
  return ( 
    <div className="programs" id="programs">
        {/* {header} */}
        <div className="programs-header">
            <span className='stroke-text'>explore our</span>
            <span>programs</span>
            <span className='stroke-text'>to shape you</span>
        </div>
        {/* {Programs categories} */}
        <div className="program-cateogry">
            {programsData.map((program)=>{
                return(
                    <div className="program-card">
                        {program.image}
                        <span>{program.heading}</span>
                        <span>{program.details}</span>
                        <div className="join-now">
                            <span>Join Now</span>
                            <img src={right} alt="" />
                        </div>
                    </div>
                );    
            })}
        </div>
    </div>
  )
}
